import formatFilters from '@/utils/formatFilters'

export default {
  getProductsFilters({ filters }) {
    const obj = formatFilters.toObject(filters?.lastRequestQueryLog?.data || [])
    return Object.values(typeof obj.columns === 'string' ? {} : obj.columns || [])
      .map((item) => ({ ...item, value: Boolean(item.value) }))
  },
}
